/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
let dqm_config = {
    dimensions : [
        {
            name: 'uniqueness',
            display : 'Uniqueness',
            visible : true
        },
        {
            name: 'completeness',
            display : 'Completeness',
            visible : true
        },
        {
            name: 'accuracy',
            display : 'Accuracy',
            visible : true
        }, 
        {
            name: 'validity',
            display : 'Validity',
            visible : true
        },
        {
            name : 'consistency',
            display : 'Consistency',
            visible : true
        }, 
        {
            name : 'compliance',
            display : 'Compliance',
            visible : true
        }
    ],
    data_sources : []      
}

export default dqm_config